export default __webpack_public_path__ + "img/8ab9a416c04c9332454ae52741db9838.svg";